import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/athlete-proposition-bet.module.scss";
import {AthletePropositionBetModuleProgressBar} from "./athlete-proposition-bet-module.progress-bar";
import {AthletePropositionBetModuleButton} from "./athlete-proposition-bet-module.button";
import {AthletePropositionBetModuleOptions} from "./athlete-proposition-bet-module.options";

export const AthletePropositionBetModuleContent = observer(({controller, row}) => {
  const {state} = controller;
  const {bookmaker, sportTypeId} = state;

  const betsImpressionParams = {
    bookieId: bookmaker?.id,
    bookieName: bookmaker?.name,
    sportTypeId
  };

  const baseProps = {
    controller,
    row
  }

  const buttonProps = {
    ...baseProps,
    betsImpressionParams,
  }

  return (
    <div className={classNames(styles.content)}>
      <div className={classNames(styles.row)}>
        <AthletePropositionBetModuleOptions {...baseProps}/>
        <AthletePropositionBetModuleProgressBar {...baseProps}/>
      </div>
      <AthletePropositionBetModuleButton {...buttonProps}/>
    </div>
  )
});
